export default class MondaySelect {

    constructor() {
        this.init();
    }


    init() {

        const monday_list = document.querySelectorAll('.monday__list');
        const all_country = ["Bangladesh", "Belgium", "Burkina Faso", "Bulgaria", "Bosnia and Herzegovina", "Barbados", "Wallis and Futuna", "Saint Barthelemy", "Bermuda", "Brunei", "Bolivia", "Bahrain", "Burundi", "Benin", "Bhutan", "Jamaica", "Bouvet Island", "Botswana", "Samoa", "Bonaire, Saint Eustatius and Saba ", "Brazil", "Bahamas", "Jersey", "Belarus", "Belize", "Russia", "Rwanda", "Serbia", "East Timor", "Reunion", "Turkmenistan", "Tajikistan", "Romania", "Tokelau", "Guinea-Bissau", "Guam", "Guatemala", "South Georgia and the South Sandwich Islands", "Greece", "Equatorial Guinea", "Guadeloupe", "Japan", "Guyana", "Guernsey", "French Guiana", "Georgia", "Grenada", "United Kingdom", "Gabon", "El Salvador", "Guinea", "Gambia", "Greenland", "Gibraltar", "Ghana", "Oman", "Tunisia", "Jordan", "Croatia", "Haiti", "Hungary", "Hong Kong", "Honduras", "Heard Island and McDonald Islands", "Venezuela", "Puerto Rico", "Palestinian Territory", "Palau", "Portugal", "Svalbard and Jan Mayen", "Paraguay", "Iraq", "Panama", "French Polynesia", "Papua New Guinea", "Peru", "Pakistan", "Philippines", "Pitcairn", "Poland", "Saint Pierre and Miquelon", "Zambia", "Western Sahara", "Estonia", "Egypt", "South Africa", "Ecuador", "Italy", "Vietnam", "Solomon Islands", "Ethiopia", "Somalia", "Zimbabwe", "Saudi Arabia", "Spain", "Eritrea", "Montenegro", "Moldova", "Madagascar", "Saint Martin", "Morocco", "Monaco", "Uzbekistan", "Myanmar", "Mali", "Macao", "Mongolia", "Marshall Islands", "Macedonia", "Mauritius", "Malta", "Malawi", "Maldives", "Martinique", "Northern Mariana Islands", "Montserrat", "Mauritania", "Isle of Man", "Uganda", "Tanzania", "Malaysia", "Mexico", "Israel", "France", "British Indian Ocean Territory", "Saint Helena", "Finland", "Fiji", "Falkland Islands", "Micronesia", "Faroe Islands", "Nicaragua", "Netherlands", "Norway", "Namibia", "Vanuatu", "New Caledonia", "Niger", "Norfolk Island", "Nigeria", "New Zealand", "Nepal", "Nauru", "Niue", "Cook Islands", "Kosovo", "Ivory Coast", "Switzerland", "Colombia", "China", "Cameroon", "Chile", "Cocos Islands", "Canada", "Republic of the Congo", "Central African Republic", "Democratic Republic of the Congo", "Czech Republic", "Cyprus", "Christmas Island", "Costa Rica", "Curacao", "Cape Verde", "Cuba", "Swaziland", "Syria", "Sint Maarten", "Kyrgyzstan", "Kenya", "South Sudan", "Suriname", "Kiribati", "Cambodia", "Saint Kitts and Nevis", "Comoros", "Sao Tome and Principe", "Slovakia", "South Korea", "Slovenia", "North Korea", "Kuwait", "Senegal", "San Marino", "Sierra Leone", "Seychelles", "Kazakhstan", "Cayman Islands", "Singapore", "Sweden", "Sudan", "Dominican Republic", "Dominica", "Djibouti", "Denmark", "British Virgin Islands", "Germany", "Yemen", "Algeria", "United States", "Uruguay", "Mayotte", "United States Minor Outlying Islands", "Lebanon", "Saint Lucia", "Laos", "Tuvalu", "Taiwan", "Trinidad and Tobago", "Turkey", "Sri Lanka", "Liechtenstein", "Latvia", "Tonga", "Lithuania", "Luxembourg", "Liberia", "Lesotho", "Thailand", "French Southern Territories", "Togo", "Chad", "Turks and Caicos Islands", "Libya", "Vatican", "Saint Vincent and the Grenadines", "United Arab Emirates", "Andorra", "Antigua and Barbuda", "Afghanistan", "Anguilla", "U.S. Virgin Islands", "Iceland", "Iran", "Armenia", "Albania", "Angola", "Antarctica", "American Samoa", "Argentina", "Australia", "Austria", "Aruba", "India", "Aland Islands", "Azerbaijan", "Ireland", "Indonesia", "Ukraine", "Qatar", "Mozambique"];

        if(monday_list.length > 0) {
            var ajaxurl = '/wp-admin/admin-ajax.php';
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_monday",
                },
                success: function (result) {

                    const convertArr = JSON.parse(result);
                    var defaultCountry = "United States";
                    const ipElement = document.querySelector('.monday__section').getAttribute('data-ip');
                    const found = convertArr.find((element) => element.country == ipElement);
                    if(found){
                        defaultCountry =  ipElement;
                    }

                    convertArr.sort(keysrt('country')).forEach(function(el, i) {
                        var countryDiv = document.createElement('div');
                        countryDiv.textContent = el.country;
                        document.querySelector('.monday__select--list').appendChild(countryDiv);

                        if (el.country === defaultCountry) {
                            document.querySelector('.monday__select>span').textContent = el.country;
                            var activeItem = document.createElement('div');
                            activeItem.className = 'monday__item active';
                            document.querySelector('.monday__list').appendChild(activeItem);
                        } else {
                            var normalItem = document.createElement('div');
                            normalItem.className = 'monday__item';
                            document.querySelector('.monday__list').appendChild(normalItem);
                        }

                        el.cards.forEach(function(ell, ind) {
                            if (ell.image) {
                                var imageDiv = document.createElement('div');
                                var img = document.createElement('img');
                                img.src = ell.image;
                                imageDiv.appendChild(img);
                                document.querySelector('.monday__list>.monday__item:nth-child(' + (i + 1) + ')').appendChild(imageDiv);
                            }
                        });
                    });

                    var countryІnput = document.createElement('input');
                    countryІnput.className = 'monday__select--input';
                    countryІnput.placeholder = "Search...";
                    document.querySelector('.monday__select--list').appendChild(countryІnput);
                }
            });
        }


        function keysrt(key) {
            return function(a,b){
                if (a[key] > b[key]) return 1;
                if (a[key] < b[key]) return -1;
                return 0;
            }
        }
        if(document.querySelectorAll('.monday__select--list').length > 0) {
            document.querySelectorAll('.monday__select>span').forEach(function (element) {
                element.addEventListener('click', function (e) {
                    var parentDiv = this.parentElement;
                    if (parentDiv.classList.contains('active')) {
                        parentDiv.classList.remove('active');
                    } else {
                        parentDiv.classList.add('active');
                    }
                });
            });

            document.querySelector('.monday__select--list').addEventListener('click', function (e) {
                if (e.target.tagName === 'DIV') {
                    var value = e.target.innerHTML;
                    var index = Array.from(e.target.parentNode.children).indexOf(e.target) + 1;

                    var mondaySelect = e.target.closest('.monday__select');
                    mondaySelect.classList.remove('active');
                    mondaySelect.querySelector('span').innerHTML = value;

                    var mondaySection = e.target.closest('.monday__section');
                    mondaySection.querySelectorAll('.monday__item').forEach(function (item) {
                        item.classList.remove('active');
                    });
                    mondaySection.querySelector('.monday__item:nth-child(' + index + ')').classList.add('active');

                    var inputElements = document.querySelectorAll('.monday__select--list input');
                    for (var i = 0; i < inputElements.length; i++) {
                        inputElements[i].value = '';
                    }

                    var divElements = document.querySelectorAll('.monday__select--list div');
                    for (var j = 0; j < divElements.length; j++) {
                        divElements[j].classList.remove('hide_search');
                    }
                }
            });

            document.querySelector('.monday__select--list').addEventListener('input', function (e) {
                e.preventDefault();
                let value = e.target.value;
                if (value) {
                    let parentDiv = e.target.closest('.monday__select--list');
                    let divs = parentDiv.querySelectorAll('div');
                    divs.forEach(function (div) {
                        let current = div.innerHTML.toLowerCase();
                        if (!current.includes(value.toLowerCase())) {
                            div.classList.add('hide_search');
                        } else {
                            div.classList.remove('hide_search');
                        }
                    });
                } else {
                    let parentDiv = e.target.closest('.monday__select--list');
                    let divs = parentDiv.querySelectorAll('div');
                    divs.forEach(function (div) {
                        div.classList.remove('hide_search');
                    });
                }
            });
        }

    }



}
